/* eslint-disable no-unused-vars */
/* eslint-disable max-len */
import {
  AccordionHeader,
  SocReminderCardAccordion,
  SocReminderCardContainer,
} from "./SOC.style";
import {
  AccordionSummary,
  Box,
  Button,
  IconButton,
  Typography,
} from "@mui/material";
import { CloseIcon, SocCompleteIcon } from "../../../components/Icons";
import {
  IPetItemResponse,
  ISOCItemResponse,
} from "../../../services/Standard-of-care/standard-of-care.interface";
import React, { useState } from "react";

import { AvatarCustom } from "../../../components";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { MIXPANEL_EVENTS } from "../../../config/mixPanelEvents";
import { CREATE_BOOKING_TYPE, MODALS } from "../../../config/params";
import SOCChildAccordion from "./SOCChildAccordion";
import SocCustomAvatar from "./SocCustomAvatar";
import { socStatusMapper } from "../../../utils/SOCUtils";
import { useAppointmentStore } from "../../../hooks/redux-hooks/appointment-store/appointment.store";
import { useModal } from "../../../context/ModalContext";
import { usePetStore } from "../../../hooks/redux-hooks/pet-store/pet-store.service";
import { userActivityLogger } from "../../../utils/mixpanel";
import { useOverdueInvoiceStore } from "../../../hooks/redux-hooks/overdue-invoice-store/overdue-invoice.store";
import { useBookingAppointmentTypeStore } from "../../../hooks";

export type ISocDataType = [string, ISOCItemResponse[]][];

type ISocReminderCard = {
  socData: ISocDataType;
  petData: IPetItemResponse;
  socIcons: { [key: string]: JSX.Element };
  handleReminder: (value: boolean) => void;
};

const SocReminderCard = (props: ISocReminderCard) => {
  const { socData, petData, socIcons, handleReminder } = props;
  const { openModal } = useModal();
  const { setSelectedPets, setReasonForVisit } = useAppointmentStore();
  const [expanded, setExpanded] = useState<string | false>(false);
  const { petList } = usePetStore();
  const { pendingPaymentPetList, isBookingBlocked, pausedWellnessPetList, cancelledWellnessPetList } = useOverdueInvoiceStore();
  const { bookingAppointmentType } = useBookingAppointmentTypeStore();

  const [expandedChild, setExpandedChild] = useState<string | false>(false);

  const handleChangeChild =
    (panel: string) => (event: React.SyntheticEvent, isExpanded: boolean) => {
      setExpandedChild(isExpanded ? panel : false);
    };

  const handleOpenSchedule = () => {
    if (!isBookingBlocked && pendingPaymentPetList.length > 0) {
      if (cancelledWellnessPetList.length > 0) {
        openModal(MODALS.PENDING_INVOICE_CANCELLED_ALERT_MODAL);
      } else if (pausedWellnessPetList.length > 0) {
        openModal(MODALS.PENDING_INVOICE_PAUSED_ALERT_MODAL);
      } else {
        openModal(MODALS.GENERIC_PAYMENT_ISSUE_MODAL);
      }
    } else {
      openModal(MODALS.UPDATED_BOOK_A_VISIT_MODAL);
    }
  };

  const handleBookAppointment = () => {
    if (petData) {
      userActivityLogger(MIXPANEL_EVENTS.BOOK_A_VISIT, {
        start_from: "care_section",
        appt_type:
          bookingAppointmentType === CREATE_BOOKING_TYPE.DROPOFF_BOOKING ?
            "drop_off" :
            "in_room_visit",
        overdue_status: pendingPaymentPetList.length > 0 ? "yes" : "no",
        is_plan_cancelled: cancelledWellnessPetList.length > 0 ? "true" : "false",
      });
      userActivityLogger(MIXPANEL_EVENTS.BOOK_A_VISIT_SELECT_PET, {
        no_of_pets: 1,
        owner_type: petList?.length == 1 ? "single_pet" : "multipet",
        referred_from: "care_section",
        appt_type:
          bookingAppointmentType === CREATE_BOOKING_TYPE.DROPOFF_BOOKING ?
            "drop_off" :
            "in_room_visit",
      });
      setSelectedPets([petData]);
      setReasonForVisit({
        [petData.id]: { reasons: "", anything: " ", socReasons: [] },
      });
      handleOpenSchedule();
    }
  };

  const handleChange =
    (panel: string) => (event: React.SyntheticEvent, newExpanded: boolean) => {
      setExpanded(newExpanded ? panel : false);
    };

  const getPendingSocCount = (SOC_STATUS: any) => {
    if (SOC_STATUS["Overdue"] > 0) {
      return { pending: SOC_STATUS["Overdue"], type: "Overdue" };
    } else if (SOC_STATUS["Almost Due"] > 0) {
      return { pending: SOC_STATUS["Almost Due"], type: "Almost Due" };
    } else if (SOC_STATUS["Incomplete"] > 0) {
      return { pending: SOC_STATUS["Incomplete"], type: "Incomplete" };
    } else if (SOC_STATUS["Current"] > 0) {
      return { pending: SOC_STATUS["Current"], type: "Current" };
    } else {
      return undefined;
    }
  };

  function updateSocStatusCount(socItems: any) {
    let pendingSocCount: { pending: string; type: string } | null | undefined =
      null;

    const SOC_STATUS: any = {
      "Overdue": 0,
      "Incomplete": 0,
      "Current": 0,
      "Almost Due": 0,
    };

    socItems.forEach((item: any) => {
      SOC_STATUS[item.status] += 1;
    });

    pendingSocCount = getPendingSocCount(SOC_STATUS);

    return pendingSocCount;
  }

  const socWithOverDueAndAlmostDue = socData?.filter((item) =>
    item?.[1]?.some((item) => item?.status !== "Current"),
  );

  return (
    <>
      <div>
        <SocReminderCardContainer>
          <IconButton
            aria-label="close"
            onClick={() => handleReminder(false)}
            sx={{ position: "absolute", right: 5, top: 8, color: "gray" }}
          >
            {/* <CloseIcon /> */}
          </IconButton>
          <Box className="child_container">
            <div className="flex gap-3 items-center">
              <AvatarCustom
                width={56}
                height={56}
                image={petData?.image}
                name={petData?.name}
                isWellnessMember={petData?.isWellnessplan}
                wellnessIconHeight={20}
                wellnessIconWidth={20}
              />
              <Typography variant="h4" fontWeight={600}>
                {petData?.name} has important care items that are{" "}
                {petData?.socStatus.toLowerCase()}.
              </Typography>
            </div>

            <div className="h-min max-h-[23rem] w-full overflow-y-auto">
              {socWithOverDueAndAlmostDue.map(
                (item: any, index: number) =>
                  item[0] !== "Preventative" && (
                    <div key={index}>
                      <SocReminderCardAccordion
                        expanded={expanded === item[0]}
                        onChange={handleChange(item[0])}
                      >
                        <AccordionSummary
                          expandIcon={<ExpandMoreIcon />}
                          aria-controls={`${item[0]}d-content`}
                          id={`${item[0]}d-header`}
                          className="!pr-3"
                        >
                          <AccordionHeader dynamicStyles={true}>
                            <Box className="title_icon">
                              {socIcons[item[0].toLowerCase()]}
                              <Typography variant="h4" fontWeight={600}>
                                {item[0]}
                              </Typography>
                            </Box>
                            <Box>
                              {updateSocStatusCount(item[1])?.type ===
                              "Current" ? (
                                  <SocCompleteIcon />
                                ) : (
                                  <SocCustomAvatar
                                    width={24}
                                    height={24}
                                    pendingSoc={
                                      updateSocStatusCount(item[1])?.pending
                                    }
                                    type={
                                    updateSocStatusCount(item[1])?.type as any
                                    }
                                  />
                                )}
                            </Box>
                          </AccordionHeader>
                        </AccordionSummary>
                        <div id="soc_child_reminder" className="pr-[0.875rem]">
                          {item[1].map(
                            (item: any, i: number) =>
                              (item.status === socStatusMapper.overdue ||
                                item.status === socStatusMapper.almostDue) && (
                                <SOCChildAccordion
                                  onClick={(item: any) => {}}
                                  isWellnessPlan={false}
                                  key={i}
                                  item={item}
                                  expandedChild={expandedChild}
                                  handleChangeChild={handleChangeChild}
                                  dynamicStyles={true}
                                  isBooking={true}
                                  petData={petData}
                                />
                              ),
                          )}
                        </div>
                      </SocReminderCardAccordion>
                    </div>
                  ),
              )}
            </div>
          </Box>

          <Button
            variant="contained"
            id="Book_a_visit_button"
            color="primary"
            disabled={isBookingBlocked}
            fullWidth
            className="!font-semibold !mt-4"
            onClick={handleBookAppointment}
          >
            Book Appointment{" "}
          </Button>
        </SocReminderCardContainer>
      </div>
    </>
  );
};

export default SocReminderCard;
